(function () {
  var header = document.querySelector('[data-sa-header]');
  if (!header) return;

  var navItems = header.querySelectorAll('[data-sa-mega-item]');
  var closeTimer = null;
  var openItem = null;

  function closeAllMega() {
    navItems.forEach(function (item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-sa-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
    openItem = null;
  }

  function openMega(item) {
    if (openItem === item) return;
    closeAllMega();
    item.classList.add('is-open');
    var trigger = item.querySelector('[data-sa-mega-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    openItem = item;
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeAllMega, 180);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  navItems.forEach(function (item) {
    var trigger = item.querySelector('[data-sa-mega-trigger]');
    var panel = item.querySelector('[data-sa-mega-panel]');
    if (!trigger || !panel) return;

    item.addEventListener('mouseenter', function () {
      cancelClose();
      openMega(item);
    });

    item.addEventListener('mouseleave', scheduleClose);

    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', scheduleClose);

    trigger.addEventListener('click', function (e) {
      if (window.matchMedia('(min-width: 990px)').matches) {
        e.preventDefault();
        if (item.classList.contains('is-open')) {
          closeAllMega();
        } else {
          openMega(item);
        }
      }
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (window.matchMedia('(min-width: 990px)').matches) {
          e.preventDefault();
          if (item.classList.contains('is-open')) {
            closeAllMega();
          } else {
            openMega(item);
          }
        }
      }
      if (e.key === 'Escape') {
        closeAllMega();
        trigger.focus();
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) closeAllMega();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllMega();
  });

  window.addEventListener('resize', function () {
    if (!window.matchMedia('(min-width: 990px)').matches) closeAllMega();
  });

  window.addEventListener('scroll', closeAllMega, { passive: true });

  /* Mobile drawer mega accordions */
  header.querySelectorAll('[data-sa-drawer-mega-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var panel = btn.nextElementSibling;
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.classList.toggle('is-open', !expanded);
    });
  });
})();
